import http, { api } from '../axios'

const updateOrganizationInfo = async data => {
  const res = await api.patch(`/organization/name`, data)
  return res
}

const OrganizationService = {
  updateOrganizationInfo
}

export default OrganizationService
